module.exports = __webpack_public_path__ + "img/product_94.be6c7eb.webp";